export default "__VITE_ASSET__50pt43ZA__"